module.exports = __webpack_public_path__ + "img/k12_room3.62231644.png";